import { Box, Card, CardActionArea, CardContent, Container, Grid, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useStyles from './style';
import { PermissionKeyType } from 'auth/permissions';
import { hasPermission } from 'auth/helper';

export type ActionGroup = {
  category?: string;
  actions: {
    title: string;
    textBody?: string;
    url: string;
    type?: 'READ' | 'UPDATE' | 'CREATE';
    isInBeta?: boolean;
    requiredPermission?: PermissionKeyType;
  }[];
};

type Props = React.ComponentPropsWithoutRef<'div'> & {
  actionGroup: ActionGroup[];
};

const ActionScreen = ({ actionGroup }: Props) => {
  const { t } = useTranslation(['useCase', 'common']);
  const { classes } = useStyles();

  return (
    <Container disableGutters maxWidth={false} className={classes.container} sx={{ px: 3 }}>
      <h1 className={classes.pageTitle}>{t('general.whatToAchieve')}</h1>
      {actionGroup?.map((group, index) => (
        <React.Fragment key={index}>
          {group.category && <h2 className={classes.groupCategory}>{group.category}</h2>}
          <Grid container spacing={3}>
            {group.actions.map((actionCard) => (
              <Grid size={3} key={actionCard.title}>
                {actionCard.requiredPermission && !hasPermission(actionCard.requiredPermission) ? (
                  <Tooltip title={t('common:permissions:InsufficientPermissions')} arrow>
                    <Card
                      variant="outlined"
                      className={`${classes.actionCardWrapper} ${actionCard.type}`}
                    >
                      <CardContent className={classes.actionCard}>
                        <Box
                          alignItems="baseline"
                          display="flex"
                          flexDirection="row"
                          justifyContent="space-between"
                        >
                          <h3>{actionCard.title}</h3>
                        </Box>
                        <p>{actionCard.textBody}</p>
                      </CardContent>
                    </Card>
                  </Tooltip>
                ) : (
                  <Link to={actionCard.url}>
                    <Card
                      variant="outlined"
                      className={`${classes.actionCardWrapper} ${actionCard.type}`}
                    >
                      <CardActionArea>
                        <CardContent className={classes.actionCard}>
                          <Box
                            alignItems="baseline"
                            display="flex"
                            flexDirection="row"
                            justifyContent="space-between"
                          >
                            <h3>{actionCard.title}</h3>
                          </Box>
                          <p>{actionCard.textBody}</p>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Link>
                )}
              </Grid>
            ))}
          </Grid>
        </React.Fragment>
      ))}
    </Container>
  );
};

export default ActionScreen;
